import type React from 'react';

import type { Register } from '../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../types/Resources';

import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import PageLoader from '@helsenorge/core-framework/page-loader';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';

import BestillInnsynComponent from './bestill-innsyn';
import MeldeFeilButton from './melde-feil-button';
import { getInnsynDialogTyper } from './utils';
import { useAppSelector } from '../../store/hooks';
import { generateUniqueKey } from '../register-dialog-types';

interface Props {
  register: Register;
  resources: HNHelseregistreJS;
}

const RegisterMeldingerContainer: React.FC<Props> = ({ register, resources }) => {
  const { RegisterDialoger: registerDialoger } = useAppSelector(state => state.registerdialogtypes);
  const {
    loading: registermeldingLoading,
    innsendingStatus,
    innsynForesporselError,
    processingRegisterId,
  } = useAppSelector(state => state.registermelding);
  if (!register.registerId || !register.herId) {
    return null;
  }
  const key = generateUniqueKey({
    registerId: register.registerId,
    herId: register.herId,
  });
  const selectedRegisterDialog = registerDialoger[key] ?? false;
  if (!selectedRegisterDialog) {
    return null;
  }

  const { loading, error, registerDialog } = selectedRegisterDialog;

  const dialogTyper = getInnsynDialogTyper(registerDialog ?? null);

  return (
    <>
      <Spacer />
      <PageLoader
        loading={loading}
        error={error ? resources.default_ErrorMessage_Title : undefined}
        errorDescription={error ? resources.default_ErrorMessage_Body : undefined}
        resources={resources}
      >
        {dialogTyper ? (
          <>
            <BestillInnsynComponent
              resources={resources}
              register={register}
              loading={registermeldingLoading}
              dialogTyper={dialogTyper}
              innsendingStatus={innsendingStatus}
              innsynForesporselError={innsynForesporselError}
              processingRegisterId={processingRegisterId}
            />
            <MeldeFeilButton register={register} resources={resources} dialogTyper={registerDialog ?? null} />
            <SafeHTML html={resources.register_tidligeresvar} tagName="p" />
          </>
        ) : null}
      </PageLoader>
    </>
  );
};

export default RegisterMeldingerContainer;
